import React from 'react';
import { Typography } from 'seagull';
import styles from "./ServiceDetails.module.scss";
export default function PriceDisplay(props) {
  const {
    priceAfterDiscount,
    priceBeforeDiscount,
    postfixPrice,
    isInButton,
    'data-testid': testid = ''
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.price,
    "data-testid": testid + 'price'
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.priceAndUnit,
    "data-testid": testid + 'price-after-discount'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: isInButton ? {
      color: 'unset'
    } : undefined
  }, priceAfterDiscount), postfixPrice && /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2",
    style: isInButton ? {
      color: 'unset'
    } : undefined
  }, postfixPrice)), priceBeforeDiscount && /*#__PURE__*/React.createElement("div", {
    className: styles.oldPrice,
    "data-testid": testid + 'price-before-discount'
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary",
    textDecoration: "line-through",
    style: isInButton ? {
      color: 'unset'
    } : undefined
  }, priceBeforeDiscount)));
}